import { isWeb } from '@lib/constants'
import { useDeepLinkingHandler } from '@lib/linking'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { useNavigation } from '@react-navigation/native'
import { useAuthStore } from '@stores/auth'
import { useEffect } from 'react'
import { View } from 'react-native'
import { RouteName } from './routeNames'
import { getTabs, TabBar } from './TabBar'

const Tab = createBottomTabNavigator()

export const Tabs = () => {
  const navigation = useNavigation()
  const [user, welcome, isAuthorized] = useAuthStore((state) => [state.user, state.welcome, state.authorized])

  useEffect(() => {
    if (isAuthorized && !welcome && user?.flags?.welcome) {
      setTimeout(() => navigation.navigate(RouteName.WelcomeModal), 1000)
    }
  }, [isAuthorized, user, welcome])

  useDeepLinkingHandler()

  return (
    <Tab.Navigator
      screenOptions={{ headerShown: false, tabBarHideOnKeyboard: true }}
      tabBar={(props) => <TabBar {...props} />}
      backBehavior={isWeb ? 'history' : 'firstRoute'}
    >
      {Object.entries(getTabs()).map(([key, { component = View }]) => (
        <Tab.Screen key={key} name={key} component={component} />
      ))}
    </Tab.Navigator>
  )
}
